import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { GridArticle, ListArticle } from './components';
import useArticlesPagination from './useArtclesPagination';
import { clsx } from 'clsx';
import { useAtom } from 'jotai';
import { useInfiniteScroll } from '@web/utils/src';
import { isInventoryListAtom } from '@/store/atoms';

interface InventoryCatalogProps {
  searchTerm?: string;
  categoryId?: string | null;
}

const InventoryCatalog = (props: InventoryCatalogProps) => {
  const { searchTerm, categoryId } = props;
  const [isList] = useAtom(isInventoryListAtom);
  const { retailerId } = useParams();
  const { t } = useTranslation();

  const { inventoryResult, fetching, error, loadMore, hasNextPage } =
    useArticlesPagination({
      retailerId: retailerId || '1',
      categoryId: categoryId || null,
      searchTerm: searchTerm ? searchTerm : '',
      perPage: 9,
    });

  useInfiniteScroll(loadMore, fetching, !hasNextPage);

  if (error) return <p>Error: {error.message}</p>;

  return (
    <div className="py-2-0">
      <p
        className={clsx(
          searchTerm ? 'text-body1' : 'text-2-0  md:text-3-2',
          'font-bd mb-3-0 md:mb-2-0',
        )}
      >
        {searchTerm ? (
          <span>
            {`${t('search_bar.search_result')}: `}
            <span className="underline">{searchTerm}</span>
          </span>
        ) : (
          t('retailer.inventory_title')
        )}
      </p>
      {inventoryResult.length > 0 ? (
        <div
          className={clsx(
            isList ? 'grid-cols-1' : 'grid-cols-1 md:grid-cols-3 ',
            'grid gap-4-0 md:gap-2-0',
          )}
        >
          {inventoryResult.map((article) =>
            !isList ? (
              <GridArticle key={article.id} article={article} />
            ) : (
              <ListArticle key={article.id} article={article} />
            ),
          )}
        </div>
      ) : (
        <p className="text-body1 mt-4-0">
          {!fetching && t('retailer.inventory_no_match')}
        </p>
      )}
      <div id="infinite-scroll-trigger"></div>
    </div>
  );
};

export default InventoryCatalog;
